const axios = require("axios").default;
import { SearchItemType } from "../../models/enums";
import { Source } from "../../models/interfaces";
import { EventSourcePolyfill, MessageEvent } from "event-source-polyfill";
import { Utils } from "../../utils";
import logger from "../../logger";

let activeEventSources: EventSourcePolyfill[] = [];
const getChatHistoryResults = async (
  url: string,
  headers: any,
) => {
  const res = await axios(url, { headers });
  return res.data


};
// const getInitialDocuments = async (url: string, headers: Record<string, string>) => {
//   try {
//     const res = await fetch(url, {
//       method: "GET",
//       headers,
//     });

//     if (!res.ok) {
//       throw new Error(`HTTP error! status: ${res.status}`);
//     }

//     const data = await res.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching initial documents:", error);
//     throw error;
//   }
// };

const getInitialDocuments = async (
  url: string,
  headers: any,
) => {
  console.log("Fetching initial documents from URL:", url);
  const res = await axios(url, { headers });
  return res.data
  // const eventSource = new EventSourcePolyfill(url);

  // eventSource.onmessage = (event: MessageEvent) => {
  //   // handle the streamed data received in the event object
  //   console.log("Initial Documents Event Data:", event.data);
  //   if (event.data === "[DONE]") {
  //     eventSource.close();
  //   }
  // }


};
const getChatbotSearchResults = async (
  url: string,
  // body: any,
  explanator: boolean,
  headers: any,
  searchResults: Function,
  answer: Function,
  errorFunc: Function,
  rtlenabled: boolean,
  dispatchFn: Function,
) => {
  if (!explanator) {
    const searchResponse = await axios(url, { headers });
    searchResults(searchResponse);
    return;
  }

  // else use event source and gpt streaming
  const eventSource = new EventSourcePolyfill(url, { headers });

  eventSource.onmessage = (event: MessageEvent) => {
    // handle the streamed data received in the event object

    if (event.data === "[DONE]") {
      eventSource.close();
    }


    // if (event.data === "[NOANSWER]") {
    //   // let answerText =
    //   //   "[NOANSWER] Please rephrase your question for better results.";

    //   // let wIndex = 0;
    //   // let timerId = setInterval(() => {
    //   // get the next word in the answer
    //   // let word = answerText.slice(wIndex, answerText.length).split(" ")[0];
    //   // wIndex += word.length + 1;
    //   // send the next word to the parent
    //   // answer(" " + word);
    //   // if (!word) {
    //   // release the timer
    //   //     clearInterval(timerId);
    //   //   }
    //   // }, 111);
    //   const regex = /\[NOANSWER\](.*)/s;
    //   const match = event.data.match(regex);
    //   if (match && match[1]) {
    //     // Return the content after '[NOANSWER]'
    //     answer(match[1].trim());
    //   } else {
    //     // Return the original content if '[NOANSWER]' is not found
    //     // return event.data;
    //     answer(event.data);
    //   }
    //   // return;
    // }

    // if error, close event source
    if (event.data.startsWith("[ERROR]")) {
      eventSource.close();
      logger.error({
        message: "EventSource error in getChatbotSearchResults",
        event_type: "[ERROR]",
        event_detail: event.data,
        url: url
      });
      errorFunc(event.data);
      return;
    }

    if (event.data.startsWith("[Warning]")) {
      eventSource.close();
      logger.error({
        message: "EventSource warning in getChatbotSearchResults",
        event_type: "[Warning]",
        event_detail: event.data,
        url: url
      });
      errorFunc(event.data);
      return;
    }

    if (event.data.startsWith("[EMPTY_INDEX]")) {
      eventSource.close();
      logger.error({
        message: "EventSource empty index in getChatbotSearchResults",
        event_type: "[EMPTY_INDEX]",
        event_detail: event.data,
        url: url
      });
      errorFunc(event.data);
      return;
    }
    answer(event.data);
  };

  eventSource.onerror = (err: any) => {
    logger.error({
      message: "EventSource failed in getChatbotSearchResults",
      error: err,
      error_detail: err.message,
      url: url
    });
    eventSource.close();
    errorFunc(err.message);
  };
};

const getSearchResults = async (
  setIsTextDone: (value: boolean) => void,
  vettedResultFlag: boolean,
  url: string,
  explanator: boolean,
  headers: any,
  searchResults: Function,
  answer: Function,
  errorFunc: Function,
  rtlenabled: boolean
) => {
  if (!explanator) {
    const searchResponse = await axios(url, { headers });
    searchResults(searchResponse);
    return;
  }
  // Check if any events is still open to close it
  for (const eventSource of activeEventSources) {
    eventSource.close();
  }
  // Clear the collection
  activeEventSources = [];

  // else use event source and gpt streaming
  const eventSource = new EventSourcePolyfill(url, { headers, heartbeatTimeout: 60000, });
  let resultsDone = vettedResultFlag;
  activeEventSources.push(eventSource);

  eventSource.onmessage = (event: MessageEvent) => {
    // handle the streamed data received in the event object

    if (event.data === "[DONE]") {
      eventSource.close();
    }
    if (event.data === "[TEXT DONE]" && vettedResultFlag) {
      resultsDone = false;
      setIsTextDone(true);
      return;
    }
    if (event.data === "[TEXT DONE]" && !vettedResultFlag) {
      setIsTextDone(true);
      return;
    }
    if (event.data === "[RESULTS DONE]") {
      resultsDone = true;
      return;
    }
    if (event.data === "[NOANSWER]") {
      return;
    }


    // if error, close event source
    if (event.data.startsWith("[ERROR]")) {
      eventSource.close();
      logger.error({
        message: "EventSource error in getSearchResults",
        event_type: "[ERROR]",
        event_detail: event.data,
        url: url
      });
      errorFunc(event.data);
      return;
    }

    if (event.data.startsWith("[WARNING]") ||
      event.data?.startsWith("[warning]")) {
      eventSource.close();
      logger.error({
        message: "EventSource warning in getSearchResults",
        event_type: "[WARNING]",
        event_detail: event.data,
        url: url
      });
      errorFunc(event.data);
      return;
    }
    if (event.data.startsWith("[EMPTY_INDEX]")) {
      eventSource.close();
      logger.error({
        message: "EventSource empty index in getSearchResults",
        event_type: "[EMPTY_INDEX]",
        event_detail: event.data,
        url: url
      });
      errorFunc(event.data);
      return;
    }
    if (!resultsDone) {
      if (event.data.startsWith("[EMPTY_INDEX]")) {

        searchResults({ data: event.data });
      } else {
        try {
          // Attempt to parse the event data
          const parsedData = JSON.parse(event.data);
          searchResults({ data: parsedData });
        } catch (error) {
          logger.error({
            message: "Failed to parse JSON data in getSearchResults",
            error: error,
            event_detail: event.data,
            stacktrace: (error as any)?.stack,
            url: url
          });
        }
        // searchResults({ data: JSON.parse(event.data) });
      }
    } else {
      answer(event.data);
    }
  };

  eventSource.onerror = (err: any) => {
    logger.error({
      message: "EventSource failed in getSearchResults",
      error: err,
      error_detail: err.message,
      url: url
    });
    eventSource.close();
    errorFunc(err.message);
  };
};


const getSourceElement = (
  element: any,
  alias: any,
  type: SearchItemType,
  highlight: boolean,
): any => {
  // take the last file name from the srcUrl
  let fileName = element?.search?._source?.srcUrl.split(/(\\|\/)/g).pop();
  let srcElement: any = {
    details: fileName,
    url: "/" + alias.workspaceAlias + "/" + alias.portalAlias,
    type,
  };
  if (!alias.workspaceAlias) {
    srcElement.url = "/workspace/" + alias.workspaceId;
  }
  if (!alias.portalAlias && alias.portalId) {
    srcElement.url += "/portal/" + alias.portalId;
  }
  // if its a video, build a url of the format /<experience alias>/kapp/kappId/video/docGuid/<doc_guid>/guid/<guid>
  if (type == SearchItemType.Video) {
    srcElement.details += " at " + videoStartTime(element);
    srcElement.url +=
      "/kapp/" +
      element?.search?.kappid +
      "/video/docGuid/" +
      element?.search?._source?.doc_guid +
      "/guid/" +
      element?.search?._source?.guid;
  } else if (type == SearchItemType.Pdf) {
    srcElement.details +=
      ", p. " + (element?.search?._source?.action?.pdfParams?.pageNumber + 1);
    // if its a document, build a url of the format /<experience alias>/kapp/kappId/pdf/docGuid/<doc_guid>/guid/<guid>
    srcElement.url +=
      "/kapp/" +
      element?.search?.kappid +
      "/pdf/docGuid/" +
      element?.search?._source?.doc_guid +
      "/page/" +
      element?.search?._source?.action?.pdfParams?.pageNumber +
      "/guid/" +
      element?.search?._source?.guid;
  } else if (type == SearchItemType.Sheet) {
    srcElement.details +=
      " " + element?.search?._source?.action?.xlsParams?.StartCell;
    // if its a document, build a url of the format /<experience alias>/kapp/kappId/pdf/docGuid/<doc_guid>/guid/<guid>
    srcElement.url +=
      "/kapp/" +
      element?.search?.kappid +
      "/sheet/docGuid/" +
      element?.search?._source?.doc_guid +
      "/guid/" +
      element?.search?._source?.guid;
  } else {
    if (highlight && !Utils.checkUrlAnchor(element?.search?._source?.srcUrl)) {
      const textTo = clacText(element);
      srcElement.details = getChapterName(element);
      srcElement.url = element?.search?._source?.srcUrl + "#:~:text=" + textTo;
    } else {
      srcElement.details = getChapterName(element);
      srcElement.url = element?.search?._source?.srcUrl;
    }
  }
  return srcElement;
};

const videoStartTime = (result: any): string => {
  const tstart = parseFloat(result?.search?._source?.action?.imageParams?.video?.tstart);
  const mins = tstart / 60;
  const numMins = Math.floor(mins);
  const fraction = mins - numMins;
  const sec = Math.floor(fraction * 60);
  if (sec < 10) {
    return numMins + ":0" + sec;
  }
  return numMins + ":" + sec;
};

const oldChapterResolver = (result: any) => {
  return result?.search?._source?.internal_path?.length > 0
    ? result.search._source.internal_path[
    result.search._source.internal_path.length - 1
    ]
    : result?.search?._source?.chapter.length > 0
      ? result?.search?._source?.chapter
      : result?.search?._source?.subject;
};
const getChapterName = (result: any) => {
  return oldChapterResolver(result);
};

const clacText = (element: any): any => {
  let chromeQueryArr = element?.search?._source?.text
    .replace(/(\r\n|\n|\r)/gm, "")
    .replace(/\s\s+/g, " ")
    .trim()
    .split(" ")
    .map((s: string) => s.replace("-", "%2D"));
  let chromeQuery: string;
  if (chromeQueryArr.length > 6) {
    let last = chromeQueryArr.length - 1;
    chromeQuery = `${chromeQueryArr[0]} ${chromeQueryArr[1]}, ${chromeQueryArr[last - 1]
      } ${chromeQueryArr[last]}`;
  } else {
    // chromeQuery = chromeQueryArr.join(" ")
    chromeQuery = element?.search?._source?.text
      .replace(/(\r\n|\n|\r)/gm, "")
      .replace(/\s\s+/g, " ")
      .trim();
  }

  return chromeQuery;
};

// export the two functions
export { getSearchResults, getSourceElement, getChatbotSearchResults, getChatHistoryResults, getInitialDocuments };
